import { React, useState, useEffect, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import $ from "jquery";

import { useStateValue } from "state";
import { countryCodes, countryCodesDictionary, regionDictionary, dummyCategories, dummyWeeklyDeal } from "constants";
import { textStrings } from "localization";

import * as Account from "assets/javascript/account";
import * as Governance from "assets/javascript/governance";
import * as Proton from "assets/javascript/proton";

import Breadcrumb from "components/breadcrumb"
import Sidebar from "components/account/sidebar";

function GovernancePage() {
    const navigate = useNavigate();
    const [state, dispatch] = useStateValue();
    const [inputs, setInputs] = useState({});
    const [data, setData] = useState({});

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, []);

    useEffect(() => {
        if (state.authenticated === null) return;

        if (!state.authenticated) {
            dispatch({
                type: "promptLogin",
                value: "/account/governance"
            });
            
            return navigate("/");
        };

        if (state.authenticated) return handleDataFetch();
    }, [state.authenticated]);

    useEffect(() => {
        if (state.fetchProposals) {
            dispatch({
                type: "fetchProposals",
                value: false
            });

            setTimeout(() => {
                return handleDataFetch();
            }, 3000);
        };
    }, [state.fetchProposals]);

    function handleDataFetch() {
        var fetchSuccess = (res) => {
            var proposalArray = res;

            if (res.length < 1) return setData(values => (
                { ...values, activeProposals: [], pastProposals: [] }
            ));

            var activeProposals = proposalArray.filter(proposal => !proposal.complete);

            var pastProposals = proposalArray.filter(proposal => proposal.complete);

            setData(values => (
                { ...values, activeProposals: activeProposals?.sort((a, b) => a.createdAt - b.createdAt), pastProposals: pastProposals?.sort((a, b) => a.createdAt - b.createdAt) }
            ));
        };

        var fetchError = (err) => {
            $("div.error-modal").addClass("error").find("div.text").html(err || "There was an error authenticating your request, please try again");
        };

        Governance.fetchProposals(state.session.auth.actor).then(res => {
            fetchSuccess(res);
        }).catch(err => {
            var { message } = err.responseJSON || { message: err };

            if (message.indexOf("Missing Cookie") != -1) {
                Account.requestToken(state.session.auth.actor).then(res => {
                    Governance.fetchProposals(state.session.auth.actor).then(res => {
                        fetchSuccess(res);
                    }).catch(err => {
                        var { message } = err.responseJSON || { message: err };

                        fetchError(message);
                    });
                }).catch(err => {
                    $("div.error-modal").addClass("error").find("div.text").html("There was an error authenticating your request, please try again");

                    navigate("/");
                });
            } else {
                fetchError(message);
            };
        });
    };

    function handleCountdown(secondsLeft) {
        if (secondsLeft <= 0) return (
            <><i className="fad fa-clock"></i> Finished</>
        );

        var days = Math.floor(secondsLeft / (60 * 60 * 24));
        var hours = Math.floor((secondsLeft % (60 * 60 * 24)) / (60 * 60));
        var minutes = Math.floor((secondsLeft % (60 * 60)) / (60));
        var seconds = Math.floor((secondsLeft % (60)));

        var plural = "";

        if (days > 0) {
            if (days > 1) plural = "s";

            return (
                <><i className="fad fa-clock"></i> { days + " day" + plural } remaining</>
            );
        } else if (hours > 0) {
            if (hours > 1) plural = "s";

            return (
                <><i className="fad fa-clock"></i> { hours + " hour" + plural } remaining</>
            );
        } else if (minutes > 0) {
            if (minutes > 1) plural = "s";

            return (
                <><i className="fad fa-clock"></i> { minutes + " minute" + plural } remaining</>
            );
        } else if (seconds > 0) {
            if (seconds > 1) plural = "s";

            return (
                <><i className="fad fa-clock"></i> { seconds + " second" + plural } remaining</>
            );
        };
    };

    function handleProposal(proposal) {
        $("div.input-modal").addClass("active").find("section.vote-proposal").addClass("active");

        dispatch({
            type: "setModal",
            value: {
                action: "vote-proposal",
                proposal: proposal
            }
        });
    };

    const breadcrumbs = [
        { label: "Home", path: "/" },
        { label: textStrings["my_account"][state.language], path: "/account" },
        { label: textStrings["account_governance"][state.language], path: "/account/governance" }
    ]

    return (
        <section className="account">
            <div className="page-header">My Account</div>

            <div className="container">
                <div className="breadcrumb-wrapper">
                    <div className="breadcrumb">
                        <Breadcrumb crumbs={breadcrumbs} />
                    </div>
                </div>

                <div className="account-wrapper">
                    <Sidebar />

                    <div className="content-wrapper">
                        <section className="active-proposals">
                            <div className="content-title-area">
                                <div className="content-title"><i className="fal fa-box-ballot"></i> { textStrings?.["account_active_proposals"]?.[state.language] }</div>
                            </div>

                            <div className="proposals">
                                <ul className="active-proposals">
                                    {
                                        (data.activeProposals == null) && (
                                            <div className="loading">
                                                <i className="fad fa-spinner-third"></i>

                                                <span>Fetching proposals</span>
                                            </div>
                                        )
                                    }

                                    {
                                        (data.activeProposals?.length < 1) && (
                                            <>
                                                <div key={ 1 } className="empty"><i className="fad fa-transporter-empty"></i> There are no active proposals to vote on</div>
                                            </>
                                        )
                                    }

                                    {
                                        data.activeProposals?.map((proposal, index) => (
                                            <li key={ index } className="click" onClick={ () => handleProposal(proposal) }>
                                                <div className="meta">
                                                    <span className="date">Submitted { new Date(proposal.createdAt).toLocaleDateString() }</span>
                                                    <span>•</span>
                                                    <span className="author">Proposed by <a href={ "https://explorer.xprnetwork.org/account/" + proposal.owner } target="_blank">{ proposal.owner }</a></span>
                                                </div>

                                                <div className="inputs">
                                                    <div className="title">{ proposal.title }</div>
                                                    <div className="description">{ proposal.description }</div>
                                                </div>

                                                <div className="stats">
                                                    <div className="time-left">{ handleCountdown( ( proposal.duration + parseInt(new Date(proposal.createdAt).getTime() / 1000) ) - parseInt( new Date().getTime() / 1000 ) ) }</div>
                                                    <div className="options"><i className="fad fa-ballot-check"></i> { proposal.options?.length } options</div>
                                                    <div className="votes"><i className="fad fa-users"></i> { proposal.votes?.length } votes</div>
                                                </div>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        </section>

                        <section className="past-proposals">
                            <div className="content-title-area">
                                <div className="content-title"><i className="fal fa-hourglass-end"></i> { textStrings?.["account_past_proposals"]?.[state.language] }</div>
                            </div>

                            <div className="proposals">
                                <ul className="past-proposals">
                                    {
                                        (data.pastProposals == null) && (
                                            <div className="loading">
                                                <i className="fad fa-spinner-third"></i>

                                                <span>Fetching proposals</span>
                                            </div>
                                        )
                                    }

                                    {
                                        (data.pastProposals?.length < 1) && (
                                            <>
                                                <div key={ 1 } className="empty"><i className="fad fa-transporter-empty"></i> There are no past proposals to view</div>
                                            </>
                                        )
                                    }

                                    {
                                        data.pastProposals?.map((proposal, index) => (
                                            <li key={ index } className="click" onClick={ () => handleProposal(proposal) }>
                                                <div className="meta">
                                                    <span className="date">Submitted { new Date(proposal.createdAt).toLocaleDateString() }</span>
                                                    <span>•</span>
                                                    <span className="author">Proposed by <a href={ "https://explorer.xprnetwork.org/account/" + proposal.owner } target="_blank">{ proposal.owner }</a></span>
                                                </div>

                                                <div className="inputs">
                                                    <div className="title">{ proposal.title }</div>
                                                    <div className="description">{ proposal.description }</div>
                                                </div>

                                                <div className="stats">
                                                    <div className="time-left"><i className="fad fa-clock"></i> Closed</div>
                                                    <div className="options"><i className="fad fa-ballot-check"></i> { proposal.options?.length } options</div>
                                                    <div className="votes"><i className="fad fa-users"></i> { proposal.votes?.length } votes</div>
                                                </div>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GovernancePage;
